/**
 * @file
 *
 * @authors zhengmeiyu (zhengmeiyu@kuaishou.com)
 * @date    2019-10-09 14:07:08
 * @version 1.0.0
 */
export default {
  enableTargetBlank: true
};
